// Feedback centralizado — toast inline (some em ~4s) e confirmação estilizada.
// Substitui alert()/confirm()/prompt() do navegador (ver centrao-docs/02).
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (t) => {
    t.addEventListener('mouseenter', Swal.stopTimer);
    t.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const toastOk = (msg) => Toast.fire({ icon: 'success', title: msg });
export const toastErro = (msg) => Toast.fire({ icon: 'error', title: msg });

// Extrai a mensagem amigável do erro do axios (backend manda { error }).
export const msgErro = (err, fallback = 'Não foi possível concluir a operação.') =>
  err?.response?.data?.error || fallback;

// Confirmação modal (retorna Promise<boolean>). perigo=true deixa o botão vermelho.
export const confirmar = ({ titulo, texto, confirmarTexto = 'Confirmar', perigo = false } = {}) =>
  Swal.fire({
    title: titulo,
    text: texto,
    icon: perigo ? 'warning' : 'question',
    showCancelButton: true,
    confirmButtonText: confirmarTexto,
    cancelButtonText: 'Cancelar',
    confirmButtonColor: perigo ? '#b53d3d' : '#1f6a2d',
    cancelButtonColor: '#6f7a70',
    reverseButtons: true,
  }).then((r) => r.isConfirmed);
